export default __webpack_public_path__ + "static/media/Jennifer.3d75eecd.png";